import { ContactFooter, Form, Home } from "../components/Contact";
import { Header } from "../components/Layouts";

function Contact() {
  return (
    <>
      <div style={{ width: "100%", height: "100%" }}>
        <Header />
        <Home />
        {/* <Form /> */}
        <ContactFooter />
      </div>
    </>
  );
}

export default Contact;
